module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/icon-mv-5174366e9a79cec4c20e5d5f569830fd.svg";